<script lang="ts">
	import { Text } from '@Shelly/shelly-design-system/index';
	import { createEventDispatcher } from 'svelte';
	import PromoItemThumbnail from '../atoms/PromoItemThumbnail.svelte';
	import PromoItemExpiryTag from '../atoms/PromoItemExpiryTag.svelte';

	/** FontAwesome icon class for thumbnail fallback */
	export let icon: string = '';
	/** Image URL for the thumbnail */
	export let image: string = '';
	/** Whether to show a notification badge on the thumbnail */
	export let hasNotification: boolean = false;
	/** Card title */
	export let title: string;
	/** Card description text */
	export let text: string;
	/** Expiry tag text (e.g. "Expires in 14 days"). Hidden when empty. */
	export let expiryText: string = '';
	/** Additional CSS class names */
	export let classNames: string = '';

	const dispatch = createEventDispatcher();
</script>

<button
	type="button"
	class="promo-item-card d-flex gap-s-plus {classNames} pr-xs pl-xs pt-xs pb-xs"
	aria-label={title}
	on:click={() => dispatch('click')}
>
	<PromoItemThumbnail {icon} {image} {hasNotification} />
	<div class="promo-item-card__content d-flex flex-direction-column gap-xs">
		<p class="promo-item-card__title">{title}</p>
		<Text styleType="body-small" class="promo-item-card__description">{text}</Text>
		{#if expiryText}
			<PromoItemExpiryTag text={expiryText} />
		{/if}
	</div>
</button>

<style>
	.promo-item-card {
		display: flex;
		width: 100%;
		padding: 0;
		margin: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		text-align: left;
		border-radius: 8px;
		transition: background 0.15s ease;
	}

	.promo-item-card:hover {
		background: var(--color-2, #1e2023);
	}

	.promo-item-card:focus-visible {
		outline: 2px solid var(--color-primary, #2491ff);
		outline-offset: 2px;
	}

	.promo-item-card__content {
		flex: 1;
		min-width: 0;
	}

	.promo-item-card__title {
		font-size: 16px;
		font-weight: 700;
		line-height: 19px;
		color: var(--color-white, #ffffff);
		margin: 0;
	}

	:global(.promo-item-card__description) {
		color: var(--color-white, #ffffff) !important;
	}
</style>
